export default {
  db: {
    serverUrl: process.env.VUE_APP_DB_SERVER ? `${process.env.VUE_APP_DB_SERVER}/` : `${window.location.origin}/db/`,
    name: process.env.VUE_APP_DB_NAME,
  },

  // s3-service-backend
  s3Api: {
    baseUrl: process.env.VUE_APP_S3_SERVICE_API_URL
      ? `${process.env.VUE_APP_S3_SERVICE_API_URL}/`
      : `${window.location.origin}/s3/api/`,
    token: process.env.VUE_APP_S3_SERVICE_API_TOKEN,
  },

  locale: {
    default: 'sv',
    fallback: 'en',
  },

  formats: {
    dateTimeUtc: 'YYYY-MM-DDTHH:mm:ssZ',
    dateShort: 'YYYY-MM-DD',
  },

  imageExtensions: ['png', 'jpg', 'jpeg', 'gif', 'svg'],

  companyRoles: [
    'Not needed',
    'Not OK',
    'Sole proprietors',
    'Hängavtal Byggnads',
    'Hängavtal Plåt-och vent',
    'Member of BF ( Byggföretagen )',
    'Member of Maskinentreprenörerna',
    'Member of Plåt-och vent company',
    'Member of Måleri company',
    'Member of Teknik company',
    'Member of Installations company',
    'Member of Elektriker union',
    'Machine Agreement',
    'Building Agreement',
  ],

  inspectionStages: {
    init: 'INIT',
    prepare: 'PREPARE',
    inProgress: 'IN_PROGRESS',
    complete: 'COMPLETE',
    finalized: 'FINALIZED',
    reported: 'REPORTED',
  },

  companyFiles: {
    statuses: {
      NOT_LOADED: 'NOT_LOADED',
      FOR_APPROVAL: 'FOR_APPROVAL',
      APPROVED: 'APPROVED',
      WRONG: 'WRONG',
    },

    codeOfConductStatuses: {
      CHECKED: 'CHECKED',
      UNCHECKED: 'UNCHECKED',
      UNKNOWN: 'UNKNOWN',
    },

    names: [
      'fTaxCertificateFile',
      'companyRegistrationFile',
      'ueFile',
      'businessInsuranceFile',
      'insuranceContractEmployeesFile',
    ],
  },

  // Used same regexp that is used on BE to validate email
  emailRegexp: /^\S+@\S+\.\S+$/,
};



// WEBPACK FOOTER //
// ./src/constants/index.js